import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface RAGRequestsTableProps {
    rags: any[];
    resourceStatuses: any[];
}

const RAGRequestsTable: React.FC<RAGRequestsTableProps> = ({
    rags, 
    resourceStatuses
}: RAGRequestsTableProps) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();
        
    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Box width="100%">
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={2}><Typography fontSize="12px">RAG NAME</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">APPLICATION</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">CATEGORY TYPE</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">CLOUD PROVIDER</Typography></Grid>
                        <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">OWNER</Typography></Grid>
                        <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">REQUESTED ON</Typography></Grid>
                        <Grid textAlign="start" item xs={1.5}><Typography fontSize="12px">ACTIONED BY</Typography></Grid>
                        <Grid item textAlign="start" xs={1}><Typography fontSize="12px">ACTIONED ON</Typography></Grid>
                    </Grid>
                </Box>
            </ListItem>
            {rags.map((rag: any, index: number) => (
                <ListItem
                    key={rag.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        cursor: "pointer",
                        bgcolor: rag.status === "active" || rag.status === "approved" ? "#FFFFFF" : rag.status === "rejected" ? "#F0443810" : "#FDB02210",
                        borderRadius: "8px",
                    }}
                    onClick={() => {
                        navigate(`/aisolutions/requests/rag/${rag.id}`); 
                    }}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => { setCardHoverIndex(null); }}
                >
                    <Box width="100%" sx={{}}>
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Grid item xs={2}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <RectangleIcon sx={{ color: rag.status === "active" || rag.status === "approved" ? "#12B76A" : rag.status === "rejected" ? "#F04438" : "#FDB022", bgcolor: rag.status === "active" || rag.status === "approved" ? "#12B76A" : rag.status === "rejected" ? "#F04438" : "#FDB022", width: "4px", marginRight: "8px" }} />
                                    <Typography fontSize="14px" fontFamily="Gilroy-Medium">{rag.ragName}</Typography>
                                    {(rag.status === 'active' || rag.status === 'approved') && resourceStatuses && resourceStatuses.length > 0 ? ( 
                                        <Tooltip sx={{ whiteSpace: "pre-line" }} title={ <Box key={`${rag.id}-tooltip`}>Current Status<br />{resourceStatuses.filter((e:any) => e.resourceId === rag.id).map((e: any, i: number) => ( <React.Fragment key={`${rag.id}-status-${i}`}>{capitalize(e.currentStatus)}<br /></React.Fragment> ))}</Box> }>
                                            <Avatar src="/assets/info.svg" alt="info" sx={{ height: 16, width: 16, marginLeft: "4px" }} />
                                        </Tooltip>
                                    ) : null}
                                </Box>
                            </Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{rag.applicationName || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{rag.solutionCategoryType || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular" sx={{textTransform: 'uppercase'}}>{rag.cloudProvider || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Avatar src={rag.ragOwnerAvatar} alt={rag.ragOwnerName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{rag.ragOwnerName ? rag.ragOwnerName.charAt(0).toUpperCase() : ''}</Avatar>
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{rag.ragOwnerName}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={1.5}>
                                <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{rag.createdAt ? moment(rag.createdAt).format("DD/MM/YYYY | hh:mm A") : 'N/A'}</Typography></Box>
                            </Grid>
                            <Grid item xs={1.5}>
                                {(rag.status === "active" || rag.status === "rejected") && (
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        {rag.ragApproverName &&
                                            <Avatar src={rag.ragApproverAvatar} alt={rag.ragApproverName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{rag.ragApproverName.charAt(0).toUpperCase()}</Avatar>
                                        }
                                        {rag.ragApproverName &&
                                            <Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>{rag.ragApproverName}</Typography>
                                        }
                                        {rag.status === "rejected" && rag.reasonForRejection && (
                                            <Tooltip title={`Reason: ${rag.reasonForRejection}`}><img src="/assets/info.svg" alt="info" /></Tooltip>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                            <Grid item xs={1}>
                                {(rag.status !== "pending" && rag.actionedAt) && (
                                    <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{moment(rag.actionedAt).format("DD/MM/YYYY | hh:mm A")}</Typography></Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </ListItem>
            ))}
        </List>
    );
};

export default RAGRequestsTable;